import { isEmpty, find } from "lodash";

const getDefaultWorkListFilterOption = (
  defaultWorkListSearchFilterRoleTypeSettings,
  currentUserRole,
  isEnableClinicalRoleReferralActiveView,
  isEnableReferralWorklistDefaultMyReferrals,
  isEnableReferralWorklistDefaultAdministrator,
) => {
  let currentActiveView = "active";
  if (isEnableClinicalRoleReferralActiveView) {
    currentActiveView = "clinicalRoleActiveView";
  } else if (isEnableReferralWorklistDefaultMyReferrals) {
    currentActiveView = "myReferrals";
  } else if (isEnableReferralWorklistDefaultAdministrator) {
    currentActiveView = "administratorFilter";
  }

  if (isEmpty(defaultWorkListSearchFilterRoleTypeSettings)) return currentActiveView;

  let defaultType = null;
  if ((!isEmpty(defaultWorkListSearchFilterRoleTypeSettings) && find(defaultWorkListSearchFilterRoleTypeSettings, x => x.roleName === currentUserRole.roleName))) {
    defaultType = find(defaultWorkListSearchFilterRoleTypeSettings, x => x.roleName === currentUserRole.roleName).defaultWorkListSearchFilterType;
  }

  return !isEmpty(defaultType) ? defaultType[0].toLowerCase() + defaultType.slice(1) : currentActiveView;
};

export default getDefaultWorkListFilterOption;
